import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { PREVENT_AUTH_HEADER } from '../services/auth/auth.interceptor';

/**
 * Fetches `assets/i18n/<lang>.json`.
 *
 * Written by hand rather than using `@ngx-translate/http-loader` for one reason:
 * that loader calls `http.get(url)` with no headers, so the request goes through
 * `apiAuthInterceptor`, and everything past that guard runs `inject(CoreProvider)`.
 * This fetch happens while `CoreProvider` is still constructing — it is the first
 * thing `CoreProvider.init()` awaits — so the interceptor would be asking for the
 * hub that is building it. `VersionService` hits the same wall fetching
 * `assets/version.json` and solves it the same way.
 */
export class AssetTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<object> {
    return this.http.get<object>(`./assets/i18n/${lang}.json`, {
      headers: { [PREVENT_AUTH_HEADER]: 'true' },
    });
  }
}
